export default __webpack_public_path__ + "static/media/danis.1af198bb.jpeg";